import { useEffect, useState } from "react";
import axios from "axios";
import { Check, Loader2, UserRound } from "lucide-react";
import "./AvatarPicker.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cachedAvatars = null;

export function useStockAvatars() {
  const [avatars, setAvatars] = useState(cachedAvatars || []);
  const [loading, setLoading] = useState(!cachedAvatars);
  useEffect(() => {
    if (cachedAvatars) return;
    (async () => {
      try {
        const r = await axios.get(`${API}/avatars/stock`);
        cachedAvatars = r.data?.avatars || [];
        setAvatars(cachedAvatars);
      } catch (_) {
        setAvatars([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  return { avatars, loading };
}

/**
 * Grid of stock presenter avatars. `value` is the avatar id, `onChange(avatar)`.
 */
export function AvatarPicker({ value, onChange, compact = false, title = "Choose your presenter" }) {
  const { avatars, loading } = useStockAvatars();
  return (
    <div className={`avp ${compact ? "avp-compact" : ""}`} data-testid="avatar-picker">
      <div className="avp-head">
        <UserRound size={15} />
        <span>{title}</span>
        <span className="avp-note">Stock avatars for now — your own avatar comes later</span>
      </div>
      {loading ? (
        <div className="avp-loading"><Loader2 className="animate-spin" size={16} /> Loading avatars…</div>
      ) : (
        <div className="avp-grid">
          {avatars.map((a) => {
            const selected = value === a.id;
            return (
              <button
                key={a.id}
                type="button"
                className={`avp-card ${selected ? "is-selected" : ""}`}
                onClick={() => onChange && onChange(a)}
                data-testid={`avatar-option-${a.id}`}
                aria-pressed={selected}
              >
                <div className="avp-photo">
                  <img src={a.image_url} alt={a.name} loading="lazy" />
                  {selected && <span className="avp-tick"><Check size={13} /></span>}
                </div>
                <div className="avp-name">{a.name}</div>
                <div className="avp-tag">{a.tagline}</div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export function AvatarChip({ avatar, size = 26 }) {
  if (!avatar) return null;
  return (
    <span className="avp-chip" data-testid="avatar-chip">
      <img src={avatar.image_url} alt={avatar.name} style={{ width: size, height: size }} />
      <span>{avatar.name}</span>
    </span>
  );
}
